export default {

    getAll(context, success, error) {
        context.$http.get('experiments').then(success, error)
    },

    getOne(context, id, success, error) {
        context.$http.get('experiments/' + id).then(success, error)
    },

    create(context, rule, success, error) {
        context.$http.post('experiments', rule).then(success, error)
    },

    update(context, rule, id, success, error) {
        context.$http.put('experiments/' + id, rule).then(success, error)
    },

    remove(context, id, success, error){
        context.$http.delete('experiments/' + id).then(success, error)
    },

    getProductExperimentData(context, id, success, error) {
        context.$http.get('experiments/product/' + id).then(success, error)
    },
}


// WEBPACK FOOTER //
// ./src/services/experiments/index.js